import React, { useState, useEffect } from 'react';
import ReportsCardholderActivityItem from './ReportsCardholderActivityItem.jsx';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const ReportsCardholderActivityList = ({ data }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(function () {
      setLoading(false);
    }, 5000);
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  } else {
    if (!data) {
      return <div>No Data to Display!</div>;
    }
  }

  return (
    <>
      {data &&
        data.length > 0 &&
        data
          .sort((a, b) => (b.transTime > a.transTime ? 1 : -1))
          .map((item, index, array) => {
            return (
              <ReportsCardholderActivityItem
                key={item.id}
                credential={item.cardNumber}
                name={item.description}
                timestamp={item.transTime}
                type={item.type}
              />
            );
          })}
    </>
  );
};

export default ReportsCardholderActivityList;
